import React from "react";
import { apiPath } from "../../utility/Constant";
import useFetch from "../../hooks/useFetch";
import { useParams } from "react-router-dom";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import GlobalForm from "../../components/globalForm/GlobalForm";

const PackageUniquePage = () => {
  const { packageApi } = apiPath;
  const param = useParams();

  // const [packageData, packageDataLoading] = useFetch(packageApi, false, param.id);
  const [packageData, packageDataLoading] = useFetch(packageApi, true);
  if (packageDataLoading) {
    return <Loading />;
  }
  const uniquePackage = packageData.find((item) => item._id === param.id);

  const { _id, packageName, price, details, reco, featured } = uniquePackage;

  const data = [
    {
      elementType: "input",
      label: "Package Name",
      type: "Text",
      name: "packageName",
      required: true,
      defaultValue: packageName,
    },
    {
      elementType: "input",
      label: "Package Price",
      type: "Text",
      name: "price",
      required: false,
      defaultValue: price,
    },
    {
      elementType: "textField",
      label: "Package Details",
      type: "Text",
      name: "details",
      required: true,
      defaultValue: details,
    },
    {
      elementType: "input",
      label: "Package Recommendation",
      type: "Text",
      name: "reco",
      required: true,
      defaultValue: reco,
    },
    {
      elementType: "select",
      label: "Featured",
      type: "Text",
      name: "featured",
      required: false,
      options: ["true", "false"],
      defaultValue: featured,
    },
  ];

  const singlePackageApi = `${packageApi}/${_id}`;

  const update = (data) => {
    updateData(singlePackageApi, data, true);
  };
  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default PackageUniquePage;
